import Vue from 'vue'
import VueRouter from 'vue-router'

// 1.安装插件
Vue.use(VueRouter);

import Home from "../views/home/Home";
import login from "../views/login/login";
// import information from "../views/information/information";
import registered from "../views/registered/registered";
import payView from "@/views/payView/payView";
import operation from "@/views/operation/operation";
import introduce from "@/views/introduce/introduce";
import summary from 'views/summary'
import fba from "@/views/fba/fba"

// 2.创建路由对象
const routes = [
  {
    path: '/index',
    name: 'index',
    component: fba
  },
  {
    path: '/summary',
    name: 'summary',
    component: summary
  },
  {
    path: '/',
    redirect: 'index'
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/registed123456',
    name: 'registered',
    component: registered
  },
  {
    path: '/userInfo11',
    component: res => require(['@/views/information/information'],res),
    name: 'information'
  },
  {
    path: '/pay',
    component: payView,
    name: 'pay'
  },
  {
    path: '/operation',
    component: operation,
    name: 'operation'
  },
  {
    path: '/introduce',
    component: introduce,
    name: 'introduce'
  },
  {
    path: '/fba',
    component: fba,
    name: 'fba'
  },
];

const router = new VueRouter({
  routes,
  mode: 'history'
})

// 3.导出router
export default router
